import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Video"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.75 19.5H3C2.17157 19.5 1.5 18.8284 1.5 18V6C1.5 5.17157 2.17157 4.5 3 4.5H15.75C16.5784 4.5 17.25 5.17157 17.25 6V9.045L21.315 6.1425C21.5432 5.98003 21.8429 5.95826 22.0922 6.08605C22.3414 6.21384 22.4987 6.46989 22.5 6.75V17.25C22.4987 17.5301 22.3414 17.7862 22.0922 17.9139C21.8429 18.0417 21.5432 18.02 21.315 17.8575L17.25 14.955V18C17.25 18.8284 16.5784 19.5 15.75 19.5ZM3 6V18H15.75V13.5C15.7513 13.2199 15.9086 12.9638 16.1578 12.8361C16.4071 12.7083 16.7068 12.73 16.935 12.8925L21 15.795V8.205L16.935 11.1075C16.7068 11.27 16.4071 11.2917 16.1578 11.164C15.9086 11.0362 15.7513 10.7801 15.75 10.5V6H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Video.vue"]]);
